import { createBrowserHistory } from "history";

export const history = createBrowserHistory({ basename: '/regs-lnwf' });
history.listen(_ => {
    window.scrollTo(0, 0)  
})